import { siteConfig } from "@/components/homepage/_config"
import { CornerPlus } from "@/components/ui/corner-plus"
import { TerminalBrowserPreviewBlock } from "@/components/homepage/animations/sections/terminal-browser-preview"
import { CodeReviewBlock } from "@/components/homepage/animations/sections/code-review-block"

const workflowConfig = siteConfig.workflowSection

export function Workflow() {
    return (
        <section id="workflow" className="w-full relative">
            <div className="mx-auto">
                {/* Centered header */}
                <div className="text-center px-6 md:px-10 lg:px-14 pt-14 md:pt-20 pb-10">
                    <h3 className="text-3xl font-medium tracking-tighter md:text-4xl">
                        {workflowConfig.sections.title}
                    </h3>
                    <p className="mt-4 text-muted-foreground text-balance max-w-md mx-auto">
                        {workflowConfig.sections.description}
                    </p>
                </div>

                {/* Two-column grid with divider */}
                <div className="grid grid-cols-1 md:grid-cols-2 md:divide-x divide-border border-t border-border">
                    <div className="relative border-b border-border flex flex-col">
                        <CornerPlus position="top-right" className="text-muted-foreground/50 hidden md:block" />
                        <TerminalBrowserPreviewBlock />
                        <div className="max-w-xl text-left items-start p-6 pb-14 mt-auto">
                            <p className="text-sm text-muted-foreground flex items-center gap-3 justify-start">
                                {workflowConfig.sections.blocks[0].icon}
                                {workflowConfig.sections.blocks[0].title}
                            </p>
                            <p className="text-base text-foreground leading-relaxed mt-2">
                                {workflowConfig.sections.blocks[0].description}
                            </p>
                        </div>
                    </div>

                    <div className="relative border-b border-border flex flex-col">
                        <CornerPlus position="top-left" className="text-muted-foreground/50 hidden md:block" />
                        <CodeReviewBlock />
                        <div className="max-w-xl text-left items-start p-6 pb-14 mt-auto">
                            <p className="text-sm text-muted-foreground flex items-center gap-3 justify-start">
                                {workflowConfig.sections.blocks[1].icon}
                                {workflowConfig.sections.blocks[1].title}
                            </p>
                            <p className="text-base text-foreground leading-relaxed mt-2">
                                {workflowConfig.sections.blocks[1].description}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
